<template>
  <section class="market-section" :class="ready ? 'render-ready' : 'render-locked'">
    <div class="market-header">
      <h2 class="market-heading">Markets</h2>
      <a href="#/markets" class="market-more">All →</a>
    </div>
    <!-- Skeleton loading state for content parity -->
    <SkeletonLoader v-if="!ready" :count="6" />
    <div v-else class="market-list">
      <div v-for="coin in displayCoins" :key="coin.id" class="market-item card-edge-glow">
        <div class="market-pair">
          <span class="pair-name">{{ coin.fromSymbol }}/{{ coin.toSymbol }}</span>
          <span class="pair-volume">{{ coin.volume }}</span>
        </div>
        <div class="market-price-col">
          <span class="pair-price number">${{ coin.price }}</span>
          <span class="pair-change number" :class="getChangeClass(coin.change)">{{ coin.change }}%</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { fetchHomeData } from '@/api'
import SkeletonLoader from '@/components/ui/SkeletonLoader.vue'

export default {
  name: 'MarketSection',
  components: { SkeletonLoader },
  data() { return { coins: [], ready: false } },
  computed: { displayCoins() { return this.coins.slice(0, 8) } },
  async mounted() {
    const data = await fetchHomeData()
    this.coins = data.coins
    await this.$nextTick()
    this.ready = true
  },
  methods: {
    getChangeClass(change) { return parseFloat(change) >= 0 ? 'up' : 'down' }
  }
}
</script>

<style scoped>
.market-section { background: var(--bg-page); padding: 0 var(--s-4) var(--s-5); }
.market-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: var(--s-3); }
.market-heading { color: var(--text-primary); font-size: var(--font-size-lg); font-weight: 700; }
.market-more { color: var(--text-dim); font-size: var(--font-size-sm); text-decoration: none; }
.market-list { display: flex; flex-direction: column; gap: 2px; background: rgba(255,255,255,0.03); border-radius: var(--radius-lg); overflow: hidden; }
.market-item { display: flex; justify-content: space-between; align-items: center; padding: var(--font-size-base) var(--s-4); border-bottom: 1px solid rgba(255,255,255,0.04); }
.market-item:last-child { border-bottom: none; }
.market-pair { display: flex; flex-direction: column; gap: var(--s-1); }
.pair-name { color: var(--text-primary); font-size: var(--font-size-base); font-weight: 600; }
.pair-volume { color: var(--text-dim); font-size: 11px; }
.market-price-col { display: flex; flex-direction: column; align-items: flex-end; gap: var(--s-1); }
.pair-price { color: var(--text-primary); font-size: var(--font-size-base); font-weight: 600; }
.pair-change { font-size: var(--font-size-xs); font-weight: 500; }
.pair-change.up { color: var(--up); }
.pair-change.down { color: var(--down); }
</style>
